module.exports = __webpack_public_path__ + "img/errorinternalserver.1f0357c.webp";